export default __webpack_public_path__ + "static/media/archywavebanner.a8571abb.webp";